module.exports = __webpack_public_path__ + "img/PEARSON_LOGO_PURPLE_RGB.c73dccfa.svg";